import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import ImageDragDrop from '~/admin/components/questions/ImageDragDrop.jsx';
import { buildImageProps } from '~/app/adapters/questionAdapters';

export default function FieldImageDragDrop({
  question: q, qIndex, disabled = false, showAns = false,
  resetSignal, showReset = true,
}) {
  const { setFieldValue, values } = useFormikContext();
  const { items, targets, answers } = buildImageProps(q);

  const handleChange = (report) => {
    console.log('[FieldImageDragDrop] onChange report', { report });
    const mapped = targets.map((t) => {
      const pid = report && report.placement ? report.placement[t.id] : null;
      if (pid == null) return null;
      const itemIdx = items.findIndex((it) => it.id === pid);
      return itemIdx >= 0 ? itemIdx : null;
    });
    console.log('[FieldImageDragDrop] mapped', { mapped });
    // schedule Formik update asynchronously to avoid updating Formik during render of child
    Promise.resolve().then(() => setFieldValue(`answers.${qIndex}.answeredSeq`, mapped));
    // log resulting form state snippet
    console.log('[FieldImageDragDrop] form values snippet', { answersRow: values.answers && values.answers[qIndex] });
  };

  return (
    <ImageDragDrop
      items={items}
      targets={targets}
      answers={answers}
      onChange={handleChange}
      value={null}
      restrictEdit={disabled}
      resetSignal={resetSignal}
      showReset={showReset}
      showAns={true}
    />
  );
}
